import { render, staticRenderFns } from "./LabelEdgesIcon.vue?vue&type=template&id=0e7aa706&"
import script from "./LabelEdgesIcon.vue?vue&type=script&lang=js&"
export * from "./LabelEdgesIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports